import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; 
import particlesConfig from "./config/ParticleConfig";
import { ToastContainer, toast } from "react-toastify";


const Design = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    try{
      initParticlesEngine(async (engine) => {
        await loadSlim(engine);
        //await loadBasic(engine);
      }).then(() => {
        setInit(true);
      });
    }catch(error){
      toast.error(`Error initializing particle engine: ${error}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
   
  }, []);

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const particlesComponent = useMemo(() => {
    return (
      <Particles
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={particlesConfig}
      />
    );
  }, []);

  return init ? particlesComponent : <></>;
};

export default Design